import { LoadingStates } from "../Util/loadingStates";

export const AI_RESPONSE_PENDING = "AI_RESPONSE_PENDING";
export const AI_RESPONSE_SUCCESS = "AI_RESPONSE_SUCCESS";
export const AI_RESPONSE_ERROR = "AI_RESPONSE_ERROR";
export const CLEAR_AI_RESPONSE = "CLEAR_AI_RESPONSE";

const initialState = {
  status: LoadingStates.IDLE,
  error: null,
  data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_RESPONSE_PENDING:
      return { ...state, status: LoadingStates.PENDING, error: null, data: null };
    case AI_RESPONSE_SUCCESS:
      return { ...state, status: LoadingStates.FINISHED, error: null, data: action.payload };
    case AI_RESPONSE_ERROR:
      return { ...state, status: LoadingStates.ERROR, error: action.error, data: null };
    case CLEAR_AI_RESPONSE:
      return initialState;
    default:
      return state;
  }
};

const storeName = "ai_response";
const storeMapping = { [storeName]: reducer };
export const aiResponseSelector = (state) => state[storeName];
export default storeMapping; 
